import React from 'react';

const AboutPage = () => {
    return (
        <div>
            <h2>Giới thiệu</h2>
            <p>Thông tin về công ty và đội ngũ của chúng tôi.</p>
        </div>
    );
};

export default AboutPage;
